import { Component, ErrorInfo, ReactNode } from 'react';
import { errorUtils } from '../utils/common';
import './ErrorBoundary.css';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null, 
            errorInfo: null 
        };
    }

    static getDerivedStateFromError(_error: Error): Partial<State> {
        return { hasError: true };
    }

    override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        
        // Hata logla
        errorUtils.logError(error, 'ErrorBoundary');
        
        // Production'da hata raporlama servisine gönder
    }

    reportError = (_error: Error, _errorInfo: ErrorInfo): void => {
        // Hata raporlama servisi (Sentry, LogRocket, vb.)
        // TODO: Backend API'ye hata raporlama eklenecek
    };

    handleRetry = (): void => {
        this.setState({ 
            hasError: false, 
            error: null, 
            errorInfo: null 
        });
    };

    override render(): ReactNode {
        if (this.state.hasError) {
            return (
                <div className="error-boundary">
                    <div className="error-content">
                        <div className="error-icon">⚠️</div>
                        <h2>Bir Hata Oluştu</h2>
                        <p>{errorUtils.formatError(this.state.error || new Error('Bilinmeyen hata'))}</p>
                        
                        <div className="error-actions">
                            <button 
                                onClick={this.handleRetry}
                                className="retry-button"
                            >
                                Tekrar Dene
                            </button>
                            <button 
                                onClick={() => window.location.reload()}
                                className="reload-button"
                            >
                                Sayfayı Yenile
                            </button>
                        </div>
                        
                        {process.env.NODE_ENV === 'development' && (
                            <details className="error-details">
                                <summary>Teknik Detaylar</summary>
                                <pre>{this.state.error && this.state.error.toString()}</pre>
                                <pre>{this.state.errorInfo?.componentStack || 'Component stack bilgisi mevcut değil'}</pre>
                            </details>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;

